import { combineReducers } from 'redux'
import {
	rbidosAccessSlice,
	rbidosCommonSlice,
	rbidosAgentSlice,
} from 'Pages/registry_business_access_neo'

export const registryBusinessAccessSlice = combineReducers({
	[rbidosAccessSlice.name]: rbidosAccessSlice.reducer,
	[rbidosCommonSlice.name]: rbidosCommonSlice.reducer,
	[rbidosAgentSlice.name]: rbidosAgentSlice.reducer,
})
